import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import { Button, Card, StandaloneScreen } from '../../../components/app2';

const TermsOfService = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate('/login');
        }
    };

    return (
        <StandaloneScreen
            maxWidth={880}
            align="top"
            title="Términos y condiciones — PaySlip"
            actions={(
                <Button variant="outline" size="sm" icon="arrow_back" onClick={handleBack}>
                    Volver
                </Button>
            )}
        >
            <Card>
                    {/* Title */}
                    <div className="text-center mb-8">
                        <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-4">
                            <Icon name="FileText" size={32} className="text-primary" />
                        </div>
                        <h1 className="text-3xl font-bold text-foreground">Términos y Condiciones</h1>
                        <p className="text-muted-foreground mt-2">
                            Actualizado el 2025-12-11
                        </p>
                    </div>

                    {/* Content Sections */}
                    <div className="max-w-none">
                        <section className="mt-8">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="FileCheck" size={20} className="mr-2 text-primary" />
                                Términos Generales
                            </h2>
                            <p className="text-muted-foreground leading-relaxed">
                                Al acceder y realizar un pedido con PaySlip, usted confirma que está de acuerdo y sujeto a los términos de servicio contenidos en los Términos y condiciones que se describen a continuación. Estos términos se aplican a todo el sitio web y a cualquier correo electrónico u otro tipo de comunicación entre usted y PaySlip.
                            </p>
                            <p className="text-muted-foreground leading-relaxed mt-4">
                                Bajo ninguna circunstancia el equipo de PaySlip será responsable de ningún daño directo, indirecto, especial, incidental o consecuente, que incluye, entre otros, la pérdida de datos o ganancias que surjan del uso o la incapacidad de usar los materiales de este sitio.
                            </p>
                        </section>

                        <section className="mt-8">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="Key" size={20} className="mr-2 text-primary" />
                                Licencia
                            </h2>
                            <p className="text-muted-foreground leading-relaxed">
                                PaySlip le otorga una licencia revocable, no exclusiva, intransferible y limitada para descargar, instalar y usar la plataforma estrictamente de acuerdo con los términos de este Acuerdo.
                            </p>
                            <p className="text-muted-foreground leading-relaxed mt-4">
                                Usted acepta estar sujeto a estos Términos y condiciones. Si no está de acuerdo con estos Términos y condiciones, no utilice el Servicio PaySlip.
                            </p>
                        </section>

                        <section className="mt-8 bg-muted rounded-lg p-6">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="BookOpen" size={20} className="mr-2 text-primary" />
                                Definiciones y Términos Clave
                            </h2>
                            <div className="space-y-4">
                                <div className="bg-card rounded-lg p-4 border border-border">
                                    <h3 className="font-semibold text-foreground">Cookie</h3>
                                    <p className="text-sm text-muted-foreground mt-1">
                                        Pequeña cantidad de datos generados por un sitio web y guardados por su navegador web. Se utiliza para identificar su navegador, proporcionar análisis, recordar información sobre usted.
                                    </p>
                                </div>
                                <div className="bg-card rounded-lg p-4 border border-border">
                                    <h3 className="font-semibold text-foreground">Compañía</h3>
                                    <p className="text-sm text-muted-foreground mt-1">
                                        Se refiere a AS BERMUDEZ & ASOCIADOS (ESTRELLA 54, GUERRERO, CUAUHTÉMOC, CIUDAD DE MÉXICO, C.P. 06300), responsable de su información en virtud de estos Términos.
                                    </p>
                                </div>
                                <div className="bg-card rounded-lg p-4 border border-border">
                                    <h3 className="font-semibold text-foreground">Plataforma</h3>
                                    <p className="text-sm text-muted-foreground mt-1">
                                        Sitio web de Internet, aplicación web o aplicación digital de cara al público de PaySlip.
                                    </p>
                                </div>
                                <div className="bg-card rounded-lg p-4 border border-border">
                                    <h3 className="font-semibold text-foreground">Servicio</h3>
                                    <p className="text-sm text-muted-foreground mt-1">
                                        Se refiere al servicio brindado por PaySlip como se describe en los términos relativos y en esta plataforma.
                                    </p>
                                </div>
                            </div>
                        </section>

                        <section className="mt-8">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="Ban" size={20} className="mr-2 text-primary" />
                                Restricciones
                            </h2>
                            <p className="text-muted-foreground mb-3">
                                Usted acepta no hacerlo y no permitirá que otros:
                            </p>
                            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
                                <li>Licenciar, vender, alquilar, arrendar, asignar, distribuir, transmitir, alojar, subcontratar, divulgar o explotar comercialmente la plataforma</li>
                                <li>Modificar, realizar trabajos derivados, desensamblar, descifrar, realizar una compilación inversa o realizar ingeniería inversa de cualquier parte de la plataforma</li>
                                <li>Eliminar, alterar u ocultar cualquier aviso de propiedad (incluido cualquier aviso de derechos de autor o marca registrada)</li>
                            </ul>
                        </section>

                        <section className="mt-8">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="RotateCcw" size={20} className="mr-2 text-primary" />
                                Política de Devolución y Reembolso
                            </h2>
                            <p className="text-muted-foreground leading-relaxed">
                                Gracias por comprar en PaySlip. Apreciamos el hecho de que le guste comprar las cosas que construimos. Al realizar un pedido o realizar una compra en PaySlip, acepta los términos junto con la Política de privacidad de PaySlip.
                            </p>
                            <p className="text-muted-foreground leading-relaxed mt-4">
                                Si por alguna razón no está completamente satisfecho con algún bien o servicio que le brindamos, no dude en contactarnos y discutiremos cualquiera de los problemas que esté atravesando con nuestro producto.
                            </p>
                        </section>

                        <section className="mt-8">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="Lightbulb" size={20} className="mr-2 text-primary" />
                                Tus Sugerencias
                            </h2>
                            <p className="text-muted-foreground leading-relaxed">
                                Cualquier comentario, idea, mejora o sugerencia que usted proporcione a PaySlip con respecto a la plataforma seguirá siendo propiedad única y exclusiva de PaySlip. PaySlip tendrá la libertad de usar, copiar, modificar, publicar o redistribuir las Sugerencias para cualquier propósito.
                            </p>
                        </section>

                        <section className="mt-8">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="Link" size={20} className="mr-2 text-primary" />
                                Enlaces a Otros Sitios Web
                            </h2>
                            <p className="text-muted-foreground leading-relaxed">
                                Los Servicios pueden contener enlaces a otros sitios web que PaySlip no opera ni controla. No somos responsables por el contenido, la precisión o las opiniones expresadas en dichos sitios web. Su navegación e interacción en cualquier otro sitio web están sujetas a las propias reglas y políticas de ese sitio web.
                            </p>
                        </section>

                        <section className="mt-8">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="Cookie" size={20} className="mr-2 text-primary" />
                                Cookies
                            </h2>
                            <p className="text-muted-foreground leading-relaxed">
                                PaySlip utiliza "cookies" para identificar las áreas de nuestro sitio web que ha visitado. Usamos cookies para mejorar el rendimiento y la funcionalidad de nuestra plataforma, pero no son esenciales para su uso. La mayoría de los navegadores web se pueden configurar para desactivar el uso de cookies.
                            </p>
                        </section>

                        <section className="mt-8">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="RefreshCw" size={20} className="mr-2 text-primary" />
                                Cambios y Actualizaciones
                            </h2>
                            <p className="text-muted-foreground leading-relaxed">
                                PaySlip se reserva el derecho de modificar, suspender o interrumpir, temporal o permanentemente, la plataforma o cualquier servicio al que se conecte, con o sin previo aviso. PaySlip puede proporcionar mejoras a las características de la plataforma, que pueden incluir parches, corrección de errores, actualizaciones y otras modificaciones.
                            </p>
                        </section>

                        <section className="mt-8">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="Users" size={20} className="mr-2 text-primary" />
                                Servicios de Terceros
                            </h2>
                            <p className="text-muted-foreground leading-relaxed">
                                Podemos mostrar o poner a disposición contenido de terceros o proporcionar enlaces a sitios web de terceros. Usted reconoce que PaySlip no será responsable de ningún Servicio de terceros, incluida su precisión, integridad, puntualidad, validez, cumplimiento de los derechos de autor, legalidad, decencia o calidad.
                            </p>
                        </section>

                        <section className="mt-8">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="Clock" size={20} className="mr-2 text-primary" />
                                Duración y Terminación
                            </h2>
                            <p className="text-muted-foreground leading-relaxed">
                                Este Acuerdo permanecerá en vigor hasta que usted o PaySlip lo rescindan. PaySlip puede, a su entera discreción, en cualquier momento y por cualquier motivo, suspender o rescindir este Acuerdo con o sin previo aviso. Tras la rescisión, deberá dejar de utilizar la plataforma y eliminar todas las copias de la misma.
                            </p>
                        </section>

                        <section className="mt-8">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="Copyright" size={20} className="mr-2 text-primary" />
                                Propiedad Intelectual
                            </h2>
                            <p className="text-muted-foreground leading-relaxed">
                                La plataforma y todo su contenido, características y funcionalidad son propiedad de PaySlip, sus licenciantes u otros proveedores de dicho material y están protegidos por leyes internacionales de derechos de autor, marcas registradas, patentes, secretos comerciales y otras leyes de propiedad intelectual. El material no puede ser copiado, modificado, reproducido, descargado o distribuido de ninguna manera sin permiso previo por escrito de PaySlip.
                            </p>
                        </section>

                        <section className="mt-8 rounded-lg p-6" style={{ background: 'var(--warn-soft)', border: '1px solid var(--warn)' }}>
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="Scale" size={20} style={{ color: 'var(--warn)', marginRight: 8 }} />
                                Acuerdo de Arbitraje
                            </h2>
                            <p className="text-muted-foreground leading-relaxed">
                                En el caso de una disputa, usted o PaySlip deben darle al otro un Aviso de Disputa. Intentarán resolver cualquier disputa mediante una negociación informal dentro de los sesenta (60) días. Si no se resuelve, la disputa se llevará a cabo exclusivamente mediante arbitraje vinculante de acuerdo con las reglas de arbitraje comercial de la Asociación Americana de Arbitraje.
                            </p>
                        </section>

                        <section className="mt-8">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="Shield" size={20} className="mr-2 text-primary" />
                                Indemnización
                            </h2>
                            <p className="text-muted-foreground leading-relaxed">
                                Usted acepta indemnizar y eximir de responsabilidad a PaySlip y a sus empresas matrices, subsidiarias, afiliadas, funcionarios, empleados, agentes, socios y otorgantes de licencias de cualquier reclamo o demanda que surja de su uso de la plataforma o violación de este Acuerdo.
                            </p>
                        </section>

                        <section className="mt-8 rounded-lg p-6" style={{ background: 'var(--danger-soft)', border: '1px solid var(--danger)' }}>
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="AlertTriangle" size={20} style={{ color: 'var(--danger)', marginRight: 8 }} />
                                Sin Garantías
                            </h2>
                            <p className="text-muted-foreground leading-relaxed">
                                La plataforma se le proporciona "TAL CUAL" y "SEGÚN DISPONIBILIDAD" y con todas las fallas y defectos sin garantía de ningún tipo. PaySlip no garantiza que la plataforma cumplirá con sus requisitos, logrará los resultados previstos, será compatible con cualquier otro software o que cualquier error será corregido.
                            </p>
                        </section>

                        <section className="mt-8">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="AlertCircle" size={20} className="mr-2 text-primary" />
                                Limitación de Responsabilidad
                            </h2>
                            <p className="text-muted-foreground leading-relaxed">
                                La responsabilidad total de PaySlip y cualquiera de sus proveedores se limitará al monto realmente pagado por usted para la plataforma. En ningún caso PaySlip será responsable de daños especiales, incidentales, indirectos o consecuentes de ningún tipo.
                            </p>
                        </section>

                        <section className="mt-8 bg-muted rounded-lg p-6">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="FileCheck2" size={20} className="mr-2 text-primary" />
                                Acuerdo Completo
                            </h2>
                            <p className="text-muted-foreground leading-relaxed">
                                El Acuerdo constituye el acuerdo completo entre usted y PaySlip con respecto a su uso de la plataforma y reemplaza todos los acuerdos escritos u orales anteriores. Estos Términos y condiciones (que incluyen e incorporan la Política de privacidad de PaySlip) contienen el entendimiento completo entre usted y PaySlip.
                            </p>
                        </section>

                        <section className="mt-8">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="HelpCircle" size={20} className="mr-2 text-primary" />
                                Contáctenos
                            </h2>
                            <p className="text-muted-foreground mb-4">
                                No dude en contactarnos si tiene alguna pregunta:
                            </p>
                            <div className="bg-muted rounded-lg p-4">
                                <div className="flex items-center space-x-2 text-muted-foreground">
                                    <Icon name="Globe" size={16} className="text-primary" />
                                    <a
                                        href="https://payslip.mx/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-primary hover:underline"
                                    >
                                        https://payslip.mx/
                                    </a>
                                </div>
                            </div>
                        </section>
                    </div>

                    {/* Footer Navigation */}
                    <div className="mt-8 pt-6 border-t border-border flex flex-col sm:flex-row justify-between items-center gap-4">
                        <Link
                            to="/privacy-policy"
                            className="flex items-center space-x-2 text-primary hover:text-primary/80 transition-colors"
                        >
                            <Icon name="Shield" size={16} />
                            <span>Ver Política de Privacidad</span>
                        </Link>
                        <button
                            onClick={handleBack}
                            className="flex items-center space-x-2 px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors"
                        >
                            <Icon name="ArrowLeft" size={16} />
                            <span>Volver</span>
                        </button>
                    </div>
            </Card>

            <p style={{ font: "500 .82rem 'Hanken Grotesk'", color: 'var(--muted)', textAlign: 'center', margin: '18px 0 0' }}>
                © {new Date().getFullYear()} PaySlip · Recibos de nómina
            </p>
        </StandaloneScreen>
    );
};

export default TermsOfService;
